<script setup lang="ts">
import { ALERT_STATUS } from "~/common/interfaces/alert-status.enum";
import { useAlertStore } from "~/stores/alert";
import { useKindsStore } from "~/stores/kinds";
import { useModalStore } from "~/stores/modal";

const { t } = useI18n();
const route = useRoute();
const alertStore = useAlertStore();
const { kindsConfirmDelete } = useModalStore();
const kindsStore = useKindsStore();

const submitKindDelete = async () => {
	await kindsStore.deleteById(kindsConfirmDelete.kind.id);

	kindsConfirmDelete.closeModal();

	if (route.name === "components-kinds-kind") {
		navigateTo("/components/kinds");
	} else if (route.name === "components-kinds") {
		kindsStore.getAll({}, kindsStore.recentGetAllQuery);
	}

	alertStore.addAlert({
		title: t("COMPONENTS.KINDS.CONFIRM_DELETE.alert.title"),
		description: t("COMPONENTS.KINDS.CONFIRM_DELETE.alert.description", { kindName: kindsConfirmDelete.kind.name }),
		status: ALERT_STATUS.SUCCESS
	});
};
</script>

<template>
	<AppModalConfirm
		:title="$t('COMPONENTS.KINDS.CONFIRM_DELETE.title')"
		:description="$t('COMPONENTS.KINDS.CONFIRM_DELETE.description', { kindName: kindsConfirmDelete.kind.name })"
		:close-button-text="$t('COMMON.noCancel')"
		:submit-button-text="$t('COMMON.yesDelete')"
		@close="kindsConfirmDelete.closeModal"
		@submit="submitKindDelete"
	/>
</template>
